import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const OPTION = 'option'
export const COUNT = 'count'
export const PERCENTAGE = 'percentage'

export default {
  [PORTUGUESE]: {
    [OPTION]: 'Opção',
    [COUNT]: 'Contagem',
    [PERCENTAGE]: 'Porcentagem',
  },

  [ENGLISH]: {
    [OPTION]: 'Option',
    [COUNT]: 'Count',
    [PERCENTAGE]: 'Percentage',
  },

  [SPANISH]: {
    [OPTION]: 'Opción',
    [COUNT]: 'Puntaje',
    [PERCENTAGE]: 'Porcentaje',
  },
}
